// Időkapu-foglaló · iter146 — shared arrival status pill.
//
// Usage:
//   <ArrivalPill status="arrived" testId="ds-arrival-status-<id>" />
//
// Renders a small coloured badge with the localised HU label. `status` is one
// of "pending" | "arrived" | "late" | "no_show". Unknown values fall back to
// pending styling. Used by DockMyBookings, DockCalendar day-detail, and the
// Kapu-szkenner page.

import React from "react";

const STYLES = {
  pending:  { label: "Nem érkezett",  bg: "rgba(148,163,184,0.15)", border: "rgba(148,163,184,0.40)", color: "#94a3b8" },
  arrived:  { label: "Érkezett",       bg: "rgba(34,197,94,0.12)",   border: "rgba(34,197,94,0.45)",   color: "#22c55e" },
  late:     { label: "Késve érkezett", bg: "rgba(243,177,74,0.14)",  border: "rgba(243,177,74,0.45)",  color: "#f3b14a" },
  no_show:  { label: "Nem jelent meg", bg: "rgba(248,113,113,0.14)", border: "rgba(248,113,113,0.45)", color: "#f87171" },
};

export default function ArrivalPill({ status, testId }) {
  const s = STYLES[status] || STYLES.pending;
  return (
    <span
      data-testid={testId}
      data-status={status || "pending"}
      style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 999,
        fontFamily: "DM Mono, monospace",
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: "0.4px",
        textTransform: "uppercase",
        background: s.bg,
        border: `1px solid ${s.border}`,
        color: s.color,
        whiteSpace: "nowrap",
      }}
    >{s.label}</span>
  );
}
